import { useEffect } from "react";

/**
 * Applique dynamiquement la palette de marque d'un tenant sur le site public.
 * Mappe accent_color / secondary_color sur les variables CSS d'accent du thème
 * (--eh-ochre, --eh-sage). Les couleurs structurelles (fonds, encre, crème)
 * restent neutres pour préserver la lisibilité et la mise en page.
 *
 * Valeurs par défaut = palette Solunary (or solaire + sauge lunaire), de sorte
 * qu'un nouveau tenant démarre sur les couleurs Solunary jusqu'à ce qu'il
 * personnalise les siennes.
 */
const SOLUNARY_ACCENT = "#E6B85C";
const SOLUNARY_SECONDARY = "#7FB8A4";

// Assombrit une couleur hex d'un facteur donné (0-1) pour dériver les variantes "deep".
function darken(hex, factor = 0.78) {
  const m = /^#?([0-9a-f]{6})$/i.exec((hex || "").trim());
  if (!m) return hex;
  const n = parseInt(m[1], 16);
  const r = Math.round(((n >> 16) & 255) * factor);
  const g = Math.round(((n >> 8) & 255) * factor);
  const b = Math.round((n & 255) * factor);
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}

export function useBrandingTheme(branding) {
  useEffect(() => {
    const root = document.documentElement;
    const accent = (branding?.accent_color || SOLUNARY_ACCENT).trim() || SOLUNARY_ACCENT;
    const secondary = (branding?.secondary_color || SOLUNARY_SECONDARY).trim() || SOLUNARY_SECONDARY;

    const overrides = {
      "--eh-ochre": accent,
      "--eh-ochre-deep": darken(accent),
      "--eh-sage": secondary,
      "--eh-sage-deep": darken(secondary, 0.7),
    };

    const previous = {};
    Object.entries(overrides).forEach(([k, v]) => {
      previous[k] = root.style.getPropertyValue(k);
      root.style.setProperty(k, v);
    });

    return () => {
      Object.keys(overrides).forEach((k) => {
        if (previous[k]) root.style.setProperty(k, previous[k]);
        else root.style.removeProperty(k);
      });
    };
  }, [branding?.accent_color, branding?.secondary_color]);
}
